import { render } from "./DefectiveItemForm.vue?vue&type=template&id=170b2ae5"
import script from "./DefectiveItemForm.vue?vue&type=script&lang=js"
export * from "./DefectiveItemForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__